
import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import mydb from './DexieManager.js';

export const store = new Vuex.Store({

    state:{

        taches:[],  //Les Taches

        links:[],   //Tableau des liens

        elements:[],  //Tableau des éléments

        scale:0.5, // Niveau de zoom

        level:0, //Niveau de profondeur
        parent:'UNIVERS', // Parent Actuel
        comingFrom:{},  //Pour remonter d'un cran facilement



        //la sidebar
        componentDroite: { name:'TabHelp', config:''} ,// Composant dans la sidebar de droite

        //couleurs par defaut
        colors:['#67C23A','#f33535','#AAAAAA','#ff7505','#3b86c5'],

        levelName:['UNIVERS','ACTIVITE','SCENARIO','QUETE','TACHE','ACTION'],

        ariane:[{level:0,parent:'UNIVERS',label:'UNIVERS'}],

        //flag pour limiter le draw pendant un mouvement (optimisation de perf)
        someThingIsMoving:true,

        //Faire apparaitre toutes les occurences
        showThisKey:'',

        //Cible qui doit reload
        mustReload:'',

        //Cible qui va changer de niveau si zoom >1.2
        focusOnTheTask:'',



    },

    mutations: {
        //*************************************************
        // SHOWING FLAG : les trucs qui doivent etre en surbrillance
        //*************************************************
        SET_SHOWINGKEY(state,tmp){
            state.showThisKey=tmp
        },

        //*************************************************
        // MOVING FLAG : ca bouge
        //*************************************************
        SET_MOVING(state,tmp){

            if(state.scale>0.5 || tmp)
                state.someThingIsMoving=tmp

        },

        //*************************************************
        // FOCUS FLAG : ca va changer de niveau si ca continue a zoomer
        //*************************************************
        SET_FOCUS(state,tmp){

                state.focusOnTheTask=tmp
        },

        //*************************************************
        // NIVEAU ACTUELLEMENT REPRESENTE
        //*************************************************
        SET_SITUATION(state,tmp){

            if(tmp.level==state.ariane.length)
                state.ariane.push(tmp)
            else{
                const i=state.ariane.indexOf(tmp)
                state.ariane=state.ariane.slice(0,i+1)
            }


            state.level=tmp.level
            state.parent=tmp.parent


        },

        SET_COMINGFROM(state,tmp){

            state.comingFrom={level:tmp.level,parent:tmp.parent}
            state.level=tmp.level
        },

        //*************************************************
        // GESTION DES ELEMENTS
        //*************************************************

        INIT_ELEMENT (state,thelist){
            state.elements=thelist
        },

        //*************************************************
        // GESTION DES TASK
        //*************************************************
        TASK_LOAD (state,tmp){
            Vue.set(state, 'taches', [...tmp]);
            //state.taches=tmp
        },

        TASK_CREATE(state,val){
            state.taches.push(val)
        },

        TASK_DELETE(state,EL){
            //taches
            state.taches=state.taches.filter( thing => (thing.id !== EL ))

            //liens
            state.links=state.links.filter( thing => (thing.from !== EL && thing.to!==EL))
        },

        TASK_UPDATE (state,theTask){

            let index=this.state.taches.findIndex(x => x.id === theTask.id)
            state.taches[index]= theTask

        },

        //*************************************************
        // APPEL A RELOAD DE LIEN
        //*************************************************

        UPDATE_TASK_LINK (state,value){
            Vue.set(state, 'mustReload', value)
        },


        //*************************************************
        // GESTION DES SIDEBAR
        //*************************************************

        DROITE_SET (state,value){

            Vue.set(state, 'componentDroite', value)
        },


        //*************************************************
        // GESTION DU SCALE
        //*************************************************

        SCALE_CHANGE (state,step){
            const futur=state.scale+step
            if(futur>=0.05) // Seuil minimal
                state.scale=futur
        },

        SCALE_SET (state,value){
            state.scale=value
        },



        //*************************************************
        // GESTION DES LIENS
        //*************************************************

        CLEARLINK (state){
          state.links=[]
        },

        INITLINK (state,thelist){
            state.links=thelist
        },

        // Ajouter un lien
        ADDLINK (state,newlink){
            state.links.push(newlink)
        },

        UPDATELINK (state,newlink){
            for (let [index, val] of state.links.entries() ) {
                if (val.id === newlink.id) {
                    state.links[index]= newlink
                    break
                }
            }
        },

        UPDATELINK_COLOR (state,fromexact){
            for (let [index, val] of state.links.entries() ) {
                if (val.fromExact === fromexact.id) {
                    state.links[index].data.color= fromexact.data.color
                }
            }
        },

        UPDATELINK_LABEL (state,fromexact){
            for (let [index, val] of state.links.entries() ) {
                if (val.fromExact === fromexact.id) {
                    state.links[index].data.label= fromexact.data.label
                }
            }
        },

        // mettre à jour les positions TO est un tableau [element,x,y]
        UPDATEPOS_TO (state,TO) {

            // au lieu de faire un filter qui flingue les index, autant faire la boucle complète

           // state.links=state.links.filter( thing => (thing.fromExact !== val ))

            state.links.forEach(function (element, index) {
                if(element.to === TO[0]){
                    const newpoints = [element.points[0], element.points[1],TO[1] , TO[2]]
                    Vue.set(state.links[index], 'points', newpoints)
                }
                else if(element.from === TO[0]){
                    const newpoints = [TO[1] , TO[2],element.points[2], element.points[3]]
                    Vue.set(state.links[index], 'points', newpoints)
                }
            })
        },



        DELETE_RESULTAT(state,val){
            state.links=state.links.filter( thing => (thing.fromExact !== val ))
        },

        DELETE_LINK(state,val){
            state.links=state.links.filter( thing => thing.data.ref!==val )
        },

        DELETE_LINKFROM(state,val){
            state.links=state.links.filter( thing => thing.from!==val )
        },

    },

    getters: {

        //***********************
        // ELEMENTS
        //***********************


        getElementList: (state) => {
            return state.elements
        },

        getElementType: (state) =>  (type) => {
            return state.elements.filter( thing =>  ( thing.type === type ) )
        },
        getElementSlug: (state) =>  (slug) => {
            return state.elements.filter( thing =>  ( thing.slug === slug ) )
        },

        getElementId: (state) =>  (ID) => {
            return state.elements.filter( thing =>  ( thing.id === ID ) )
        },

        //***********************
        // FLAGS
        //***********************

        isSomeThingToShow(state){
            return state.showThisKey
        },

        isSomeThingMoving: (state) => {
            return state.someThingIsMoving
        },

        isFocusOn: (state) => {
            return state.focusOnTheTask
        },

        isSituation: (state) =>{
            return {level:state.level,parent:state.parent}
        },

        isComingFrom: (state) =>{

            if(state.level>0)
                return state.ariane[state.level-1]
            else
                return state.ariane[0]
        },
        getAriane: (state) =>{

            return state.ariane
        },

        //***********************
        // TASK
        //***********************

        getTaskList: (state) => {
            return state.taches
        },


        storeLinks: (state) => {
            return state.links
        },

        storeGetAllLinkMe: (state) =>  (id) => {
            return state.links.filter( thing =>  ( thing.from === id || thing.to === id) )
        },

        storeGetLinkFromMe: (state) =>  (id) => {
            return state.links.filter( thing =>   thing.from === id  )
        },

        storeGetLinkFromTo: (state) =>  (from,to) => {
            //return state.links.filter( thing =>   (( thing.from === from || thing.to === from) && ( thing.from === to || thing.to === to)  ))
            return state.links.filter( thing =>   (( thing.from === from ) && (  thing.to === to)  ))

        },
        storeGetLinkFromToInverse: (state) =>  (from,to) => {
            //return state.links.filter( thing =>   (( thing.from === from || thing.to === from) && ( thing.from === to || thing.to === to)  ))
            return state.links.filter( thing =>   (( thing.from === to ) && (  thing.to === from)  ))

        },

        //***********************
        // DIVERS
        //***********************

        getScale: (state) => {
            return state.scale
        },

        getDroite: (state)  => {
            return state.componentDroite
        },

        getMustReload: (state)  => {
            return state.mustReload
        },

        getTaskMessage: (state)  => {
            return {sidebar:state.componentDroite,reload:state.mustReload}
        },


        getColorUsed: (state) =>{
            const used=[...new Set(state.links.map(x =>x.data.color))]
            const total=state.colors.concat(used)
            const final=[...new Set(total)]
            return final
        },

        getLevelName: (state) =>{
          return state.levelName
        },

    },

    actions:{

        //EN attentent si ya un probleme de refresh sur les changement de pos
        updateThePos ({ commit },TO) {
            setTimeout(() => {
                commit('UPDATEPOS_TO',TO)
            }, 1)
        },

        //****************************
        // ELEMENTS

        async updateElement({commit}){
            let tmp=await mydb.do.getElementListAll();
            commit('INIT_ELEMENT',tmp);
            return true;
        },

        //****************************
        // TASK
        async load({ commit }){
            let tmp=await mydb.do.loadTask();
            commit('TASK_LOAD',tmp);
            return true;
        },

        async loadOf({ commit },target){

            let tmp=await mydb.do.loadTaskOf(target.level,target.parent);
            commit('TASK_LOAD',tmp);
            return true;
        },

        async delTask({ commit },idTask){
            let tmp=await mydb.do.deleteTask(idTask);
            commit('TASK_DELETE',idTask);
            return true;
        },

        async upTask({ commit },myTask){
            let tmp=await mydb.do.updateTask(myTask);
            commit('TASK_UPDATE',myTask);
            return true;
        },



    }

})